import React from 'react';
import { Switch } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  switchToggle: {
    width: 44,
    height: 24,
    padding: 0,
    '& .MuiSwitch-switchBase': {
      padding: 2,
      '&.Mui-checked': {
        transform: 'translateX(20px)',
        '& + .MuiSwitch-track': {
          backgroundColor: '#3966f8',
          opacity: 1
        }
      }
    },
    '& .MuiSwitch-thumb': {
      width: 20,
      height: 20,
      backgroundColor: '#ffffff',
      boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
    },
    '& .MuiSwitch-track': {
      width: 44,
      height: 24,
      borderRadius: 12,
      backgroundColor: '#d3d3d3',
      opacity: 1,
      transition: 'background-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms'
    }
  }
}));

const SwitchToggle = props => {
  const { checked, onChange, ariaLabel, name, className, ...other } = props;
  const { classes } = useStyles();

  return (
    <Switch
      checked={checked}
      onChange={onChange}
      aria-label={ariaLabel}
      name={name}
      className={className || classes.switchToggle}
      {...other}
    />
  );
};

export default SwitchToggle;
